import { IXFilter } from './IXFilter';
import { IODataFilter, IFilter } from '../common/models';
export class ODataFilter implements IXFilter {

    private expand = false;
    generateFilter(data: any) {
        return this.generateODataFilter(data);
    }

    public getFilterOperations(): string[] {
        return ['Select Operator', 'Equals', 'Not Equals', 'Contains', 'Starts With', '<', '<=',
                    '>', '>='];
    }

    public generateViewFilter( data: any ): any {
        return data.view.ListViewXml;
    }

    public generateField(field: any): any {
        return { InternalName: field.InternalName, Title: field.Title, Type: field.TypeAsString, Id: field.Id};
    }

    public generateDefaultField(): any {
        return { InternalName: '', Title: 'Select field', Type: '', Id: ''};
    }

    public generateDefaultValue(): any {
      return { value: 'Select value', id: ''};
    }

    public generateViewObject(view: any): any {
        return { Title: view.Title, ListViewXml: view.ViewQuery };
    }

    public getFilterObject(query: any): IFilter[] {
        return (<IODataFilter>query).filters;
    }

    public generateDefaultView(): any {
        return { Title: 'Select a View', ListViewXml: '' };
    }

    private getLogicalOp(op:  string) {
      switch (op) {
        case 'And':
        case 'AND':
        case '\'And\'':
        case '\'AND\'':
          return 'and';
        case 'Or':
        case 'OR':
        case '\'Or\'':
        case '\'OR\'':
          return 'or';
      }
    }

    private generateODataFilter(data: any): any {
        if ( ! data.filters ) {
          return '';
        }
        let filter = '';
        for ( let i = 0; i < data.filters.length; i++) {
          const f = data.filters[i];
          const fAsString = this.generateFilterForField(f);
          filter += fAsString;

          if ( f.logicalOp && i !== data.filters.length - 1) {
            filter += ' ' + this.getLogicalOp(f.logicalOp) + ' ';
          }
        }
        return filter;
      }

      private generateFilterForField(flt: any): string {
        if (!flt || !flt.field || !flt.operator || !flt.value) {
          return '';
        }

        if (flt.value === '' || flt.field === '' || flt.operator === '') {
          return '';
        }

        if (!flt.field.InternalName) {
          return '';
        }

        let isText = false;
        if (flt.field.Type === 'Text' || flt.field.Type === 'Note') {
          isText = true;
        }

        if (flt.field.Type === 'User' || flt.field.Type === 'UserMulti' ||
          flt.field.Type === 'Lookup' || flt.field.Type === 'LookupMulti') {
            this.expand = true;
        }

        switch (flt.operator) {
          case 'Equals':
            if ( isText ) {
              const val = this.formatValue(flt.value, flt.field.Type);
              return `${flt.field.InternalName} eq '${val}'`;
            }
            if ( this.expand ) {
              return flt.field.InternalName + '/Id eq ' + this.formatValue(flt.value, flt.field.Type);
            }
            return flt.field.InternalName + ' eq ' + this.formatValue(flt.value, flt.field.Type);
          case 'Not Equals':
            if ( isText ) {
              const val = this.formatValue(flt.value, flt.field.Type);
              return `${flt.field.InternalName} ne '${val}'`;
            }
            if ( this.expand ) {
              return flt.field.InternalName + '/Id ne ' + this.formatValue(flt.value, flt.field.Type);
            }
            return flt.field.InternalName + ' ne ' + this.formatValue(flt.value, flt.field.Type);
          case 'Contains':
            return `substringof('${flt.value}',${flt.field.InternalName})`;
          case 'Starts With':
            return `startswith(${flt.field.InternalName},'${flt.value}')`;
          case '<=':
            return flt.field.InternalName + ' le ' + this.formatValue(flt.value, flt.field.Type);
          case '<':
            return flt.field.InternalName + ' lt ' + this.formatValue(flt.value, flt.field.Type);
          case '>':
            return flt.field.InternalName + ' gt ' + this.formatValue(flt.value, flt.field.Type);
          case '>=':
            return flt.field.InternalName + ' ge ' + this.formatValue(flt.value, flt.field.Type);
          default:
            return '';
        }
      }

      private formatValue(val, type): string {
        switch (type) {
          case 'DateTime':
              return `datetime'${val}'`;
          case 'Lookup':
          case 'LookupMulti':
          case 'UserMulti':
          case 'User':
            if (!val.id) {
              return undefined;
            }
            return val.id.toString();
          default:
              return val;
        }
      }
}
